import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import 'rc-slider/assets/index.css';

import AppRoutes from './AppRoutes';

function App() {
  return (
    <div className="App">

      <AppRoutes />

    </div>
  );
}

export default App;
